<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
               
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                // console.log("selected ", selectedItem)
                if (this.field.key == 'basicInfo.zakatId') {
                    if (
                        selectedItem.dataSegmentId ==
                        process.env.VUE_APP_SSA_ACCOUNT
                    ) {
                        this.$store.commit('updateField', {
                        key: 'asaanAccInfo.zakatDeduction',
                        value: selectedItem.value,
                    })
                    } else {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.zakatDeduction',
                            value: selectedItem.value,
                        })
                    }
                    
                   this.$store.commit('updateField', {
                        key: 'basicInfo.zakat',
                        value: selectedItem.title,
                    })
                   
                }
            }
        },
    }, // End of Component > watch
}
</script>
